export default __webpack_public_path__ + "static/media/password_key.c1ba69da.svg";